import React, { useEffect, useState } from "react";
import PhotoService from "../../services/photo.service";

export default function SecuredImage(props) {
  const { filename, ...rest } = props;
  const [image, setImage] = useState("");

  useEffect(() => {
    let active = true;
    let objectUrl;
    setImage("");

    if (!filename) return undefined;
    if (/^(https?:|blob:|data:)/i.test(filename)) {
      setImage(filename);
      return undefined;
    }

    const securedImage = PhotoService.getSecuredURL(filename);
    fetch(securedImage.url, { headers: securedImage.headers })
      .then((response) => {
        if (!response.ok)
          throw new Error(`Image request failed: ${response.status}`);
        return response.blob();
      })
      .then((blob) => {
        if (!active) return;
        objectUrl = window.URL.createObjectURL(blob);
        setImage(objectUrl);
      })
      .catch(() => {
        if (active) setImage("");
      });

    return () => {
      active = false;
      if (objectUrl) window.URL.revokeObjectURL(objectUrl);
    };
  }, [filename]);

  return <img alt="" src={image} {...rest} />;
}

SecuredImage.propTypes = {};
SecuredImage.defaultProps = {};
